import { render, staticRenderFns } from "./SelectStoryIntegratingWithTelegramBot.vue?vue&type=template&id=9031dfd0"
import script from "./SelectStoryIntegratingWithTelegramBot.vue?vue&type=script&lang=js"
export * from "./SelectStoryIntegratingWithTelegramBot.vue?vue&type=script&lang=js"
import style0 from "./SelectStoryIntegratingWithTelegramBot.vue?vue&type=style&index=0&id=9031dfd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports